import * as React from 'react';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import { AgentDeliveryRequest } from '@/actions/orgSettings';

export interface DeliveryFormValues {
    url: string;
}

export const toDeliveryRequest = (values: DeliveryFormValues): AgentDeliveryRequest => ({ url: values.url.trim() });

export const DeliveryFields: React.FC = () => (
    <Form.Item
        name="url"
        label="Webhook URL"
        extra="Runway notifies this agent here when it's assigned to or unassigned from a Triage issue."
        rules={[
            { required: true, whitespace: true, message: 'Webhook URL is required' },
            { pattern: /^https:\/\/\S+$/, message: 'URL must start with https://' },
        ]}
    >
        <Input placeholder="https://example.com/runway-webhook" />
    </Form.Item>
);
